import './Sidebar.css';
import SidebarNavLinks from './SidebarNavLinks';
import HeaderImage from '../../image/header.png';
import SidebarAccount from './SidebarAccount';

const Sidebar = ({ isOpen = false, onClose = () => {} }) => {
  return (
    <aside className={`sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <img src={HeaderImage} alt="Header" className="sidebar-header-image" />
        <button
          type="button"
          className="sidebar-close-btn"
          onClick={onClose}
          aria-label="Close navigation"
        >
          ✕
        </button>
      </div>
      <nav className="sidebar-nav">
        <SidebarNavLinks onNavigate={onClose} />
      </nav>
      <div className='sidebar-account-section'>
        <SidebarAccount />
      </div>
    </aside>
  );
};

export default Sidebar;
